var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"applinkmain",class:_vm.applicationListToggle
      ? [_vm.$style.applicationsList, _vm.$style.open]
      : [_vm.$style.applicationsList]},[_c('FormBaseApplicationLinkRoutes',{attrs:{"applications":_vm.applications,"active":_vm.active,"status":_vm.status,"type":_vm.type},on:{"click":_vm.setCurrentApplication}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }